import { Route, useRoute } from 'config/routes';

export const useCheckProjectPage = () => {
  const { route } = useRoute();
  return route.name === Route.ProjectPage || route.name === Route.ProjectPageCommercial;
};
